import React, { useState } from "react";
import { useMoodsContext } from "store/contexts/moodsContext";
import UserService from "services/UserService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSmile } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { CSSTransition } from "react-transition-group";
import ClickAwayListener from "react-click-away-listener";

var styles = {
  relative: {
    position: "relative",
  },
  selectedEmoji: {
    width: "100%",
    height: "100%",
  },
  everyEmoji: {
    paddingLeft: "16px",
  },
  emojiList: {
    display: "flex",
    paddingBottom: "8px",
    paddingTop: "8px",
    listStyle: "none",
    backgroundColor: "#434343",
    alignItems: "center",
  },
  boxShadow: {
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
  },
  clearEmoji: {
    verticalAlign: "middle",
  },
};

export default ({ profile, children, isOwner }) => {
  const classes = styles;
  const [showMoods, setShowMoods] = useState(null);
  const { moods } = useMoodsContext();

  const showMoodsPooper = (event) => {
    setShowMoods(event.currentTarget);
  };

  const hideMoodsPooper = () => {
    setShowMoods(null);
  };

  const clearPostReaction = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    UserService.updateUserMood(null);

    setShowMoods(null);

    profile.profile.mood_id = null;
  };

  const updateReaction = (newReactionId, event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    if (newReactionId === profile.profile.mood_id) {
      clearPostReaction(event);
      return;
    }

    setShowMoods(null);

    UserService.updateUserMood(newReactionId);

    profile.profile.mood_id = newReactionId;
  };

  if (!moods || !moods.length) {
    return null;
  }

  let selectedMood = moods.find((mood) => {
    return mood.id === profile.profile.mood_id;
  });

  selectedMood = selectedMood ? (
    <img
      className="userProfileEmoji"
      src={selectedMood.media}
      alt={selectedMood.name}
    />
  ) : (
    <FontAwesomeIcon
      icon={faSmile}
      style={classes.clearEmoji}
      className="userProfileEmoji"
    />
  );
  return (
    <div
      className={classNames({
        noPointerEvent: isOwner ? false : true,
      })}
      onMouseEnter={showMoodsPooper}
      onClick={showMoodsPooper}
      onMouseLeave={hideMoodsPooper}
    >
      {profile?.profile?.mood_id && selectedMood}
      {!profile?.profile?.mood_id && (
        <FontAwesomeIcon
          className="userProfileEmoji"
          icon={faSmile}
          style={classes.clearEmoji}
        />
      )}

      <CSSTransition
        in={Boolean(showMoods)}
        timeout={300}
        unmountOnExit
        classNames="dropdown-element"
      >
        <ClickAwayListener onClickAway={hideMoodsPooper}>
          <div style={classes.boxShadow} className="postUserMoods">
            <ul style={classes.emojiList}>
              {moods.map((mood) => (
                <li
                  onClick={(e) => updateReaction(mood.id, e)}
                  key={mood.name}
                  style={classes.everyEmoji}
                  className="userProfileLink"
                >
                  <img
                    src={mood.media}
                    alt={mood.name}
                    key={mood.id}
                    className="userProfileEmoji"
                  />
                </li>
              ))}
            </ul>
          </div>
        </ClickAwayListener>
      </CSSTransition>
    </div>
  );
};
